import { useContext, useEffect, useState } from "react";
import { CartContext, SettingsContext } from "../App";
import CartQtySelector from "./CartQtySelector";
import { PiPencilSimple } from "react-icons/pi";
import PlusIcon from "../icons/PlusIcon";
import {
	getDefaultProductConfiguration,
	hasProductCustomizations,
	hasRemovableIngredients,
} from "./productConfiguration";

function AddToCartButton({ product }) {
	const { settings, setSelectedProduct, setProductSheet, handleAddProduct } =
		useContext(SettingsContext);
	const { cart, updateQty } = useContext(CartContext);
	const [cartID, setCartID] = useState(false);
	const [cartQty, setCartQty] = useState(0);
	const enableFlow = settings?.orders?.enable_flow ?? settings?.selfordering?.enable_flow;
	const hasCustomizations = hasProductCustomizations(product);
	const allowOptionalVariantsDirectCartAdd =
		settings?.menu_api?.allow_optional_variants_direct_cart_add == 1;

	useEffect(() => {
		if (!cart) return;
		let id = false;
		let qty = 0;
		for (const cartProduct of cart.products) {
			if (cartProduct.product_id == product.id) {
				if (id === false) id = cartProduct.item_id;
				qty += parseInt(cartProduct.qty);
			}
		}
		setCartID(id);
		setCartQty(qty);
	}, [cart]);

	const hasVariants2 = () => {
		let response = false;
		for (const variants_category of product.variants_categories) {
			if (variants_category.variants2.length > 0) response = true;
		}
		return response;
	};

	const openVariantsEditor = () => {
		setProductSheet(false);
		setSelectedProduct(product);
	};

	const handleQuickAdd = () => {
		if (hasCustomizations) {
			if (!allowOptionalVariantsDirectCartAdd) {
				openVariantsEditor();
				return;
			}

			const configuration = getDefaultProductConfiguration(product);
			if (configuration.hasRequiredSelections) {
				openVariantsEditor();
				return;
			}

			handleAddProduct({
				...product,
				qty: 1,
				variants: configuration.variants,
				products: configuration.products,
				notes: configuration.notes,
			});
			return;
		}

		handleAddProduct({
			...product,
			qty: 1,
			variants: [],
			products: [],
			notes: "",
		});
	};

	return (
		<>
			{hasCustomizations && allowOptionalVariantsDirectCartAdd && (
				<>
					<button className="button button-circle button-edit" onClick={openVariantsEditor}>
						<PiPencilSimple />
					</button>
					<button
						className="button button-circle button-add"
						onClick={handleQuickAdd}
						style={{
							backgroundColor: settings.selfordering.color1,
							color: settings.selfordering.color2,
						}}
					>
						<PlusIcon />
					</button>
				</>
			)}
			{hasCustomizations && !allowOptionalVariantsDirectCartAdd && (
				<button
					className="button button-circle button-add"
					onClick={openVariantsEditor}
					style={{
						backgroundColor: settings.selfordering.color1,
						color: settings.selfordering.color2,
					}}
				>
					<PlusIcon />
				</button>
			)}
			{product.variants_categories.length == 0 &&
				!hasRemovableIngredients(product) &&
				!hasVariants2() &&
				(settings.selfordering.show_inline_qty == 0 ||
					enableFlow == 1) && (
					<button
						className="button button-circle button-add"
						onClick={handleQuickAdd}
						style={{
							backgroundColor: settings.selfordering.color1,
							color: settings.selfordering.color2,
						}}
					>
						<PlusIcon />
					</button>
				)}
			{enableFlow == 0 &&
				settings.selfordering.show_inline_qty == 1 &&
				product.variants_categories.length == 0 &&
				!hasRemovableIngredients(product) && (
					<CartQtySelector
						value={cartQty}
						onChange={(qty) =>
							updateQty(
								product.id,
								cartID,
								qty,
								product.discounted ? product.discount.price : product.price
							)
						}
						ifEmpty={handleQuickAdd}
					/>
				)}
		</>
	);
}

export default AddToCartButton;
